module.exports = __webpack_public_path__ + "static/media/breadcrumb-divisor.5f845d72.svg";